<template>
  <div id="staff" class="column is-12">
    <div class="columns is-multiline">
      <div class="column is-4 has-text-centered" v-for="(person, idx) in staff" :key="idx">
        <figure>
          <img :src="$store.state.imgBase + person.AvatarUrl" />
        </figure>
        <h4 class="title is-4">{{ person.Name }}</h4>
        <h6 class="subtitle is-6">{{ person.Function }}</h6>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'staff',
  computed: {
    staff () {
      var tmp = []
      if (this.$store.state.staff.length > 0) {
        tmp = this.$store.state.staff
      }
      return tmp
    }
  }
}
</script>

<style lang="scss" scoped>
#staff{
  figure{
    margin-bottom: 1rem;
    img{
      height: 100px;
      width: auto;
      border-radius: 50%;
    }
  }
}
</style>
